import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MovieModel } from 'src/app/core/interfaces/movie.model';
import { MoviesService } from 'src/app/core/services/movies.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-catalogue',
  templateUrl: './catalogue.component.html',
  styleUrls: ['./catalogue.component.css'],
})
export class CatalogueComponent implements OnInit {
  movies: MovieModel[] = [];
  loading = false;
  scrollLoading = false;
  allLoaded = false;
  nextFrom = 0;
  readonly pageSize = environment.catalogue_page_size;

  constructor(private moviesService: MoviesService, private router: Router) { }

  ngOnInit(): void {
    this.loadInitial();
  }

  async loadInitial() {
    this.loading = true;
    this.nextFrom = 0;
    this.allLoaded = false;

    try {
      const page = await this.moviesService.getOnlineMoviesInRange(this.nextFrom, this.pageSize).toPromise();
      this.movies = page || [];
      this.nextFrom = this.movies.length;
      this.allLoaded = !page || page.length < this.pageSize;
    } catch {
      Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
    } finally {
      this.loading = false;
    }
  }

  async loadNextScroll() {
    try {
      const page = await this.moviesService.getOnlineMoviesInRange(this.nextFrom, this.pageSize).toPromise();
      if (page && page.length > 0) {
        this.movies = this.movies.concat(page);
        this.nextFrom += page.length;
      }
      this.allLoaded = !page || page.length < this.pageSize;
    } catch {
      this.allLoaded = true;
    } finally {
      this.scrollLoading = false;
    }
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    const scrollingElement = event.target.scrollingElement;
    if (!scrollingElement) {
      return;
    }

    const remaining = scrollingElement.scrollHeight - scrollingElement.scrollTop;
    if (remaining < environment.home_scroll_offset) {
      if (!this.scrollLoading && !this.allLoaded && !this.loading) {
        this.scrollLoading = true;
        this.loadNextScroll();
      }
    }
  }

  goMovie(idMovie) {
    this.router.navigate(['/movie', idMovie]);
  }
}
